<script>
const format = (data, type) => {
  switch (type) {
    case 'string':
      return data && String(data)
    case 'number':
      return data && Number(data)
    default:
      return data
  }
}
const filterValue = (value, data) => {
  for (let i = 0; i < data.length; i++) {
    const item = data[i]
    const _value = format(value, typeof item.value)
    if (_value === item.value) return _value
  }
  return new Error('不存在的value')
}

const computedValue = (value, data, isDefault, defaultValue) => {
  if (Array.isArray(value)) {
    const _value = value.reduce((result, v) => {
      const val = filterValue(v, data)
      if (!(val instanceof Error)) result.push(val)
      return result
    }, [])
    if (_value.length === 0) return isDefault ? defaultValue : []
    return _value
  }
  const _value = filterValue(value, data)
  if (_value instanceof Error) return isDefault ? defaultValue : ''
  return _value
}

const getDefaultValue = (data, context, callback) => {
  const { value } = data[0] || {}
  if (callback) return format(callback(data, context), typeof value)
  return value
}
export default {
  name: 'SelectPark',

  functional: true,

  inheritAttrs: false,

  props: {
    value: null,
    options: {
      type: Array,
      validator (value) {
        return value.every(item => item.hasOwnProperty('label') && item.hasOwnProperty('value'))
      },
      default () {
        return []
      }
    },
    placeholder: String,
    loading: Boolean,
    loadingText: {
      type: String,
      default: '加载中...'
    },
    default: Boolean,
    setDefault: Function,
    data: null, // 请求数据的参数
    router: Boolean, // 解析路由参数
    attr: String // 组件对应的prop
  },

  render (h, context) {
    const { value, options, loading, loadingText, placeholder, setDefault, default: isDefault } = context.props
    const defaultValue = getDefaultValue(options, context, setDefault)
    const _value = computedValue(value, options, isDefault, defaultValue)
    return (
      <el-select
        value={ loading ? '' : _value }
        placeholder={ loading ? loadingText : placeholder }
        { ...context.data }
      >
        { options.map(({ label, value }) => <el-option label={ label } value={ value } title={label} />) }
      </el-select>
    )
  }
}
</script>
